import { render } from "./legend.vue?vue&type=template&id=11b32475&scoped=true"
import script from "./legend.vue?vue&type=script&lang=js"
export * from "./legend.vue?vue&type=script&lang=js"

import "./legend.vue?vue&type=style&index=0&id=11b32475&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b32475"]])

export default __exports__